<ng-container *transloco="let t">
  <label class="juno-checkbox" [class]="labelClass()" [class.juno-checkbox--disabled]="disabled()">
    <input
      #box
      type="checkbox"
      class="juno-checkbox__input"
      [id]="controlId()"
      [name]="controlId()"
      [checked]="checked()"
      [disabled]="disabled()"
      [attr.aria-label]="label() ? null : t(ariaLabel()) || null"
      [attr.aria-required]="required()"
      [attr.aria-busy]="pending()"
      [attr.aria-invalid]="showError()"
      [attr.aria-describedby]="showError() ? controlId() + '-error' : null"
      (change)="checked.set(box.checked)"
      (blur)="touch.emit()"
    />
    <span class="juno-checkbox__box" [class]="appliedClasses()?.box" [class.juno-checkbox__box--error]="showError()">
      <!-- Same path and viewBox as `.mdc-checkbox__checkmark`, so the tick is geometrically
           identical to the `<mat-checkbox>` used elsewhere in the app. The draw-in comes from
           `stroke-dashoffset` in the stylesheet. -->
      <svg class="juno-checkbox__tick" viewBox="0 0 24 24" focusable="false" aria-hidden="true">
        <path class="juno-checkbox__tick-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59" />
      </svg>
    </span>
    @if (label()) {
    <span class="juno-checkbox__label" [class]="appliedClasses()?.label">
      {{ t(label()) }} @if (!disabled() && required()) {
      <span class="text-danger" aria-hidden="true"> *</span>
      }
    </span>
    }
  </label>
  @if (showError()) {
  <!-- `role="alert"` announces the message when it appears; `aria-describedby` above ties it
         to the control for anyone who navigates back to it. WCAG 2.2 SC 3.3.1. -->
  <div [id]="controlId() + '-error'" role="alert">
    <juno-libs-ui-error [errors]="errors()" [appliedClasses]="appliedClasses()?.error"></juno-libs-ui-error>
  </div>
  }
</ng-container>
